import Component from './interior-controller';

export default Component;